<template>
  <div class="hello" style="background-color: #fff; min-height: 100vh">
    <div style="padding: 20px 20px">
      <!-- 顶部图片 -->
      <van-image
        width="100%"
        radius="10px"
        :src="require('../assets/picture/zsyz-bg.png')"
      />
      <!-- 年份下拉表 -->
      <div>
        <van-row type="flex" justify="end">
          <van-col span="4">
            <select
              v-model="selectYear"
              @change="selectChange($event)"
              class="selectClass"
            >
              <option
                v-for="(item, index) in selectYearsColumns"
                :key="index"
                :value="item"
              >
                {{ item }}
              </option>
            </select>
          </van-col>
        </van-row>
      </div>

      <!-- 按钮题目 -->
      <van-row type="flex" justify="space-between" style="flex-wrap: wrap">
        <van-col
          span="11"
          class="flex-xc-yc"
          :style="
            'background-color:' +
              item.color +
              '; border-radius: 4px; margin-top: 20px; height: 70px; padding: 6px 6px;'
          "
          v-for="(item, index) in zsyzDataAll"
          :key="index"
          @click="clickMethod(item.activeName)"
        >
          <div
            style="
              font-size: 16px;
              font-weight: 400;
              color: #fff;
              text-align: center;
            "
          >
            {{ item.name }}
          </div>
        </van-col>
      </van-row>
      <!-- 月份显示 -->
      <div
        v-for="(item, index) in zsyzDataAll"
        :key="index"
        v-show="item.activeName == active"
      >
        <div class="cardBackground_zsyz cardCls flex-between">
          <div
            v-for="(item2, index2) in item.monthList"
            :key="index2 + '' + index"
            :style="{ backgroundColor: `${item.color}` }"
            @click="OpenDetail(active, item2.value)"
          >
            {{ item2.label }}
          </div>
        </div>
      </div>
    </div>

    <!-- 表格图表弹窗 -->
    <van-dialog
      v-model="showZsyz"
      :showConfirmButton="false"
      style="width: 95%; height: calc(100% - 90px)"
    >
      <div class="vanDialogClass">
        <!-- 最顶部标题 -->
        <h3 style="text-align: initial; color:#000">
          <span style="color:#24A4DE;">▋</span> {{ tableTitle }}
        </h3>

        <!-- 稳商扩资表格区域 -->
        <div
          v-if="tableTitle == '北仑区稳商扩资项目情况'"
          class="tableBoxClass"
        >
          <div class="tableTitleClass">
            {{ selectYear + '年 ' + currentMonth + '月' }}
          </div>
          <div class="tableParent">
            <table class="tableCls wskzTable">
              <thead>
                <tr v-for="i in level" :key="i">
                  <th
                    v-for="(item, j) in tableConfig.columns"
                    :key="i + ' ' + j"
                    :rowspan="item.rowSpan"
                    :colspan="item.colSpan"
                  >
                    {{ item.text }}
                  </th>
                </tr>
              </thead>
              <tbody v-if="showZsyz && tableData.length > 0">
                <tr v-for="(item, i) in tableData" :key="i">
                  <td
                    v-for="(thItem, j) in tableConfig.columns.filter(
                      x => x.key
                    )"
                    :key="j"
                  >
                    {{ item[thItem.key] }}
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              style="height: 20px; width: 100%;color: darkgoldenrod; text-align: center; margin-top:20px;"
              v-if="tableData.length == 0"
            >
              暂无数据
            </div>
          </div>
        </div>

        <!-- 招商引资表格区域 -->
        <div
          v-if="tableTitle == '北仑区招商引资项目情况'"
          class="tableBoxClass"
        >
          <div class="tableTitleClass">
            {{ selectYear + '年 ' + currentMonth + '月' }}
          </div>
          <div class="tableParent">
            <table class="tableCls zsyzTable">
              <thead>
                <tr v-for="i in level" :key="i">
                  <th
                    v-for="(item, j) in tableConfig.columns"
                    :key="i + ' ' + j"
                    :rowspan="item.rowSpan"
                    :colspan="item.colSpan"
                  >
                    {{ item.text }}
                  </th>
                </tr>
              </thead>
              <tbody v-if="showZsyz && tableData.length > 0">
                <template v-for="(item, index) in tableData">
                  <tr
                    :key="index2 + 's1' + index"
                    v-for="(item2, index2) in item.list"
                  >
                    <template v-for="(item3, index3) in tableConfig.columns">
                      <td
                        :key="index3"
                        v-if="index2 == 0 && index3 == 0"
                        :rowspan="item.list.length"
                      >
                        {{ item[item3.key] }}
                      </td>
                      <td v-else-if="index3 > 0" :key="index3 + 's2'">
                        {{ item2[item3.key] }}
                      </td>
                    </template>
                  </tr>
                </template>
              </tbody>
            </table>
            <div
              style="height: 20px; width: 100%;color: darkgoldenrod; text-align: center; margin-top:20px;"
              v-if="tableData.length == 0"
            >
              暂无数据
            </div>
          </div>
        </div>

        <div class="closeBtnClass" @click="CloseDetail">
          关闭
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { ApiGetZSYZ, ApiGetWSKZ } from '@/api/zsyz.js'
import { getDict } from '../api/zdqd.js'

export default {
  name: 'zsyz',
  data() {
    return {
      active_zysz: 0,
      showZsyz: false,
      active: '',
      tableDataObj: null,
      tableConfig: {},
      tableData: [],
      tableTitle: '',
      level: 1,
      // 当前年份
      selectYear: process.env.VUE_SELECT_YEAR,
      // selectYear: new Date().getFullYear(),
      // 当前月份
      currentMonth: new Date().getMonth() + 1,
      // 后台获取的年份列表
      selectYearsColumns: [],
      zsyzDataAll: []
    }
  },
  components: {},
  async created() {
    // 通过后台配置的字典，拿到年份
    getDict('selectyear_list').then(res => {
      res.data.content.forEach(x => {
        this.selectYearsColumns.push(x.label)
      })
    })
    this.getZSYZDataFn()
  },
  methods: {
    async getZSYZDataFn() {
      const res = await ApiGetZSYZ({
        year: this.selectYear,
        month: this.currentMonth
      })
      const res2 = await ApiGetWSKZ({
        year: this.selectYear,
        month: this.currentMonth
      })
      this.zsyzDataAll = [
        {
          name: '招商引资',
          activeName: 'zsyz',
          color: '#6AA7F8',
          monthList: [
            { label: '1月', value: 1 },
            { label: '2月', value: 2 },
            { label: '3月', value: 3 },
            { label: '4月', value: 4 },
            { label: '5月', value: 5 },
            { label: '6月', value: 6 },
            { label: '7月', value: 7 },
            { label: '8月', value: 8 },
            { label: '9月', value: 9 },
            { label: '10月', value: 10 },
            { label: '11月', value: 11 },
            { label: '12月', value: 12 }
          ],
          tableConfig: {
            columns: [
              { text: '类别', key: 'name' },
              { text: '排名', key: 'rank' },
              { text: '考核单位', key: 'org' },
              { text: '考核分', key: 'score' }
            ]
          },
          tableData: [],
          title: '北仑区招商引资项目情况'
        },
        {
          name: '稳商扩资',
          activeName: 'wskz',
          color: '#65C9BD',
          monthList: [
            { label: '1月', value: 1 },
            { label: '2月', value: 2 },
            { label: '3月', value: 3 },
            { label: '4月', value: 4 },
            { label: '5月', value: 5 },
            { label: '6月', value: 6 },
            { label: '7月', value: 7 },
            { label: '8月', value: 8 },
            { label: '9月', value: 9 },
            { label: '10月', value: 10 },
            { label: '11月', value: 11 },
            { label: '12月', value: 12 }
          ],
          tableConfig: {
            columns: [
              { text: '序号', key: 'sort' },
              { text: '街道/片区', key: 'street' },
              { text: '已开工数量', key: 'num' },
              { text: '累加数量', key: 'total' },
              { text: '新增建筑面积(平方米)', key: 'area' },
              { text: '已开工项目预计投资总额(万元)', key: 'amount' }
            ]
          },
          tableData: [],
          title: '北仑区稳商扩资项目情况'
        }
      ]
      this.zsyzDataAll[0].tableData = res.data
      this.zsyzDataAll[1].tableData = res2.data
    },
    clickMethod(id) {
      this.active = id
    },
    CloseDetail() {
      this.showZsyz = false
    },
    async OpenDetail(active, month) {
      this.currentMonth = month
      await this.getZSYZDataFn()
      if (active == 'zsyz') {
        if (month == 1) {
          return
        }
        // if (month == 6 || month == 3) {
        //   this.$router.push({
        //     path: '/zsyzOrigin',
        //     query: {
        //       year: this.selectYear,
        //       type: 'zsyz',
        //       month: month
        //     }
        //   })
        //   return
        // }
        this.tableConfig = this.zsyzDataAll[0].tableConfig
        this.tableData = this.zsyzDataAll[0].tableData
        this.tableTitle = this.zsyzDataAll[0].title
      } else {
        if (month == 1) {
          return
        }
        // if (month == 6 || month == 3) {
        //   this.$router.push({
        //     path: '/zsyzOrigin',
        //     query: {
        //       year: this.selectYear,
        //       type: 'wskz',
        //       month: month
        //     }
        //   })
        //   return
        // }
        this.tableConfig = this.zsyzDataAll[1].tableConfig
        this.tableData = this.zsyzDataAll[1].tableData
        this.tableTitle = this.zsyzDataAll[1].title
      }
      this.getColumnConfig(this.tableConfig.columns, 1)
      this.showZsyz = true
    },
    getColumnConfig(columns, level) {
      if (level > this.level) {
        this.level = level
      }
      columns.forEach(item => {
        // 合并行属性
        item.rowSpan = 1
        // 合并列属性
        item.colSpan = 1
      })
    },
    selectChange(e) {
      this.selectYear = e.target.value
    }
  }
}
</script>

<style scoped>
.vanDialogClass {
  text-align: initial;
  padding: 25px 20px;
  height: 100%;
}
.tableBoxClass {
  margin-top: 20px;
  color: #000;
  height: 100%;
}
.tableTitleClass {
  width: 100%;
  background-color: #e2ebf8;
  font-weight: 700;
  text-align: center;
  color: #000;
  border-radius: 10px 10px 0 0;
  padding: 5px 0;
}

/* 稳商扩资样式 */
/* 招商引资样式 */
.tableCls {
  font-size: 14px;
  font-weight: 700;
  border-collapse: collapse;
  text-align: center;
  width: 100%;
}
.tableParent {
  overflow: auto;
  height: calc(100% - 200px);
}
table thead {
  position: sticky;
  top: 0;
  background-color: #fff;
}
table thead th,
table tbody td {
  border: 1px solid #e3edf6;
  padding: 5px;
}
table tbody td {
  font-weight: 400;
  color: #000;
}
.zsyzTable thead th:nth-child(1),
.zsyzTable thead th:nth-child(3),
.zsyzTable tbody td:nth-child(1),
.zsyzTable tbody td:nth-child(3) {
  width: 100px;
}
.cardBackground_zsyz {
  flex-wrap: wrap;
}
.cardBackground_zsyz div {
  width: 70px;
  margin: 5px;
  text-align: center;
  padding: 8px 0;
  color: #fff;
  border-radius: 5px;
}
.closeBtnClass {
  position: absolute;
  bottom: 20px;
  left: 40px;
  width: 80%;
  height: 45px;
  line-height: 45px;
  background-color: #24a4de;
  text-align: center;
  border-radius: 30px;
  color: #fff;
  letter-spacing: 16px;
}
.van-dialog >>> .van-dialog__content {
  height: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/zsyz.vue